module.exports = __webpack_public_path__ + "static/media/battery-decharge.00b61fce.png";